import { useState, useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import { scrollState } from "@/lib/site";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Offer } from "@/components/landing/Offer";
import { Benefits } from "@/components/landing/Benefits";
import { Process } from "@/components/landing/Process";
import { Trust } from "@/components/landing/Trust";
import { Areas } from "@/components/landing/Areas";
import { QuizSection } from "@/components/landing/QuizSection";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";
import { QuizModal } from "@/components/landing/QuizModal";
import { QuizProvider, useQuiz } from "@/hooks/QuizContext";
import { AdminDashboard } from "@/components/AdminDashboard";

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    scrollState.lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      scrollState.lenis = null;
    };
  }, []);
};

const LandingPage = () => {
  useLenis();
  const { isOpen, closeQuiz, ctaOrigin, initialArea } = useQuiz();

  return (
    <MotionConfig reducedMotion="user">
      <a href="#conteudo" className="skip-link" data-testid="skip-link">Pular para o conteúdo</a>
      <Header />
      <main id="conteudo" className="grain">
        <Hero />
        <Marquee />
        <Offer />
        <Benefits />
        <Process />
        <Trust />
        <Areas />
        <QuizSection />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <QuizModal isOpen={isOpen} onClose={closeQuiz} ctaOrigin={ctaOrigin} initialArea={initialArea} />
    </MotionConfig>
  );
};

function App() {
  const [path, setPath] = useState(window.location.pathname + window.location.hash);

  useEffect(() => {
    const onLocationChange = () => setPath(window.location.pathname + window.location.hash);
    window.addEventListener("popstate", onLocationChange);
    window.addEventListener("hashchange", onLocationChange);
    return () => {
      window.removeEventListener("popstate", onLocationChange);
      window.removeEventListener("hashchange", onLocationChange);
    };
  }, []);

  const isAdmin = path.startsWith("/admin") || path.includes("#admin");

  if (isAdmin) {
    return <AdminDashboard />;
  }

  return (
    <QuizProvider>
      <LandingPage />
    </QuizProvider>
  );
}

export default App;
